<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div class="pb-3">
        <button
          @click.prevent="processSchedule(true)"
          :disabled="loading || hasReadonly"
          class="button is-primary is-rounded"
        >
          Save
        </button>
      </div>
      <div scheduling class="notification headerColor" v-if="formData">
        <div class="box is-12">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(processSchedule)" class="form">
                <fieldset>
                  <div class="columns">
                    <div class="column is-12">
                      <b-field label="Scheduling Selection">
                        <b-select
                          v-model="formData.scheduleSelection"
                          required="true"
                          placeholder="Select a Schedule"
                          :disabled="isReadOnly || hasReadonly"
                          @input="processInputSelection"
                        >
                          <option
                            v-for="option in scheduleList"
                            :value="option.value"
                            :key="option.value"
                            :disabled="isReadOnly || hasReadonly"
                          >
                            {{ option.label }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                  <div v-if="showFutureDates === true" class="force-center">
                    <div class="force-center subtitle pb-5">
                      Select the future date and time for delivery.
                    </div>
                    <div class="force-center columns">
                      <div class="force-center calendar-height column is-9">
                        <DateTimePicker
                          :hideTimer="
                            mailingType !== undefined && mailingType === 'Mail' ? true : false
                          "
                          :disabled="isReadOnly === true"
                          ref="futureDeliveryDate"
                          :point="point"
                          :processDateSelection="processDateSelection"
                        />
                      </div>
                    </div>
                    <div class="small-text" v-if="myTimezone">
                      {{ `Timezone: ${myTimezone || ''}` }}
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import DateTimePicker from '@/components/inputs/DateTimePicker'

export default {
  name: 'SchedulingCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly,
    DateTimePicker
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'mailMessage',
        'emailMessage',
        'emailMessageSubject',
        'mailingCommunicationID',
        'deliveryDate',
        'communicationDescription',
        'isColor',
        'isFullDuplex',
        'hasReadonly'
      ])
    })
  },

  async mounted() {
    this.loading = true

    await this.reload()

    await this.pointInit()

    await this.loadHoaTimezone()

    this.loading = false
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        saveSchedule: { title: 'Save Communication Schedule' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}

.calendar-height {
  min-height: 400px !important;
}
</style>
